import script from "./KnowledgePage.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgePage.vue?vue&type=style&index=0&id=7d47e910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d47e910"]])

export default __exports__